import { guardChildNodeByType, parseChildrenWithoutText } from '@utils/ast';
import { iframeComponentParsers } from './component.iframe.js';
import { imageComponentParsers } from './component.image.js';
import { mediaComponentParsers } from './component.media.js';
import { sliderComponentParsers } from './component.slider.js';
import { textComponentParsers } from './component.text.js';

const parseAccordionComponent = (options) => (node, context) => {
  const children = Array.from(node.childNodes).filter(guardChildNodeByType("AccordionChild")).map((it) => parseAccordionPanel(it, context)).filter((panel) => panel !== null);
  if (children.length === 0) {
    return null;
  }
  return {
    nodeType: "accordion-component",
    id: node.getAttribute("id") ?? void 0,
    options: {
      autoCollapse: !(options == null ? void 0 : options.disableAutoCollapse) && node.getAttribute("auto-collapse") === "true"
    },
    children
  };
};
function parseAccordionPanel(node, context) {
  return {
    nodeType: "accordion-component.panel",
    meta: {
      title: decodeURIComponent(node.getAttribute("title") ?? "")
    },
    options: {
      titleTag: extractTitleTag(node.getAttribute("headingTag") ?? ""),
      expandedInitially: node.getAttribute("open-initially") === "true"
    },
    children: parseChildrenWithoutText(
      node,
      {
        ...iframeComponentParsers,
        ...imageComponentParsers,
        ...mediaComponentParsers,
        ...sliderComponentParsers,
        ...textComponentParsers
      },
      context.depth + 1
    )
  };
}
function extractTitleTag(input) {
  const titleTag = input.toLowerCase();
  switch (titleTag) {
    case "h1":
    case "h2":
    case "h3":
    case "h4":
    case "h5":
    case "h6":
      return titleTag;
    default:
      return "h3";
  }
}
const makeAccordionComponentParsers = (options) => ({
  accordion: parseAccordionComponent(options)
});
const accordionComponentParsers = makeAccordionComponentParsers();

export { accordionComponentParsers, makeAccordionComponentParsers };
//# sourceMappingURL=component.accordion.js.map
